







/**
 * A simple label component with update capabilities for internationalization.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Label } from '@/core/i18n-label/type/label.type';

@Component
export default class I18nLabel extends Vue {
    /**
     * An optional map of dynamic parameters to replace placeholders in a translation.
     */
    @Prop()
    parameters?: object;

    /**
     * An optional way to deliver the label to display instead of the default slot and "parameters".
     */
    @Prop({
        default: null,
    })
    label!: Label | string | null;

    /**
     * An icon to prepend to the label.
     */
    @Prop({
        default: null,
    })
    prependIcon!: string | null;

    // DATA ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * The translation for the given label key.
     * @default null
     */
    key: string | null = null;

    // COMPUTED ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    get i18nKey(): string {
        let label;
        if (this.label) {
            if (typeof this.label === 'string') {
                label = this.label;
            } else {
                label = this.label?.i18nKey;
            }
        } else {
            label = this.key;
        }
        return label;
    }

    get params(): any {
        if (this.parameters) {
            return this.parameters;
        }
        if (this.label) {
            if (typeof this.label === 'string') {
                return {};
            } else {
                return this.label?.parameters ?? {};
            }
        }

        return {};
    }

    // LIFECYCLE ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Reads the labels's label key from the default slot of the component and retrieves the translation.
     */
    mounted(): void {
        this.readSlotContent();
    }

    /**
     * Reads the labels's label key from the default slot of the component and retrieves the translation.
     */
    updated(): void {
        this.readSlotContent();
    }

    // METHODS /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /**
     * Reads the labels's label key from the default slot of the component and retrieves the translation.
     */
    readSlotContent(): void {
        if (this.$slots.default) {
            const slotContent = this.$slots.default![0].text!.trim();
            if (slotContent && slotContent.length) {
                this.key = slotContent;
            }
        }
    }
}
